// src/pages/ChangelogPage.jsx
import React from 'react';
import {
  Typography,
  Card,
  CardContent,
  Stack,
  Box,
  List,
  ListItem,
  ListItemDecorator,
  ListItemContent,
} from '@mui/joy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const changelogData = [
  {
    version: '1.1.2',
    date: '2025-07-12',
    changes: [
      'Aggiunto supporto upload immagini checklist',
      'Le sezioni non completate ora si colorano di giallo (non verde)',
    ],
  },
  {
    version: '1.1.0',
    date: '2025-07-05',
    changes: [
      'Aggiunto supporto upload immagini checklist',
      'Ottimizzata performance su Android',
    ],
  },
  {
    version: '1.0.2',
    date: '2025-06-15',
    changes: ['Inserito stato di compilazione parziale della checklist', 'Fix bug'],
  },
  {
    version: '1.0.0',
    date: '2025-06-01',
    changes: ['Prima release'],
  },
];

export default function ChangelogPage() {
  return (
    <Card sx={{ maxWidth: 600, mx: 'auto', mt: 10, p: 3 }}>
      <CardContent>
        <Stack spacing={3}>
          {/* Logo + intestazione */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
            <img
              src={`${process.env.REACT_APP_SERVER_HOST}/assets/img/logo/SEM.svg`}
              alt="Logo SEM"
              style={{ width: 40, height: 40 }}
            />
            <Typography component="h1" level="h5">
              SEM - Admin
            </Typography>
          </Box>

          <Box>
            <Typography level="h4">Changelog 📋</Typography>
            <Typography level="body-sm" color="neutral">
              Ultimi aggiornamenti dell'applicazione
            </Typography>
          </Box>

          {/* Lista changelog */}
          <Stack spacing={2}>
            {changelogData.map((entry) => (
              <Box key={entry.version}>
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                  <Typography level="title-md">Versione {entry.version}</Typography>
                  <Typography level="body-sm" color="neutral">
                    ({new Date(entry.date).toLocaleDateString('it-IT')})
                  </Typography>
                </Box>

                <List size="sm" sx={{ mt: 1 }}>
                  {entry.changes.map((change, idx) => (
                    <ListItem key={idx}>
                      <ListItemDecorator>
                        <CheckCircleIcon fontSize="small" />
                      </ListItemDecorator>
                      <ListItemContent>{change}</ListItemContent>
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
